import React from 'react'
import './InfoBox.css'

function About({ImageSource,InfoHeader,InfoText}) {
    return(
        <div id='Info-Container'>
            <img id='Info-Image' src={ImageSource} alt=""/>
            <div id='Text-Section'>
                <p id='Info-Header'>{InfoHeader}</p>
                <p id='Info-Text'>{InfoText}</p>
            </div>
        </div>
    )
}

export default About